// npm
import moment from 'moment'
//
import { getUpdatesSettings } from '@/rest/settings'
import { getLastUpdateDate, setLastUpdateDate, putSettingsToStorage, getStoredSettings } from '@/utils/settings'

const state = {
  settings: null
}

const mutations = {
  SET_SETTINGS: (state, settings) => {
    state.settings = Object.freeze(settings)
  },
  SET_SETTING: (state, setting) => {
    state.settings = { ...state.settings, [setting.name]: setting.value }
  }
}

const actions = {
  /**
   * initialization on login or reload page
   *
   * @param commit
   * @param state
   * @returns {*|Promise<any>}
   */
  autoinit ({ commit, state }) {
    return actions.loadUpdates({ commit, state })
  },
  autodestroy ({ commit, state }) {
    commit('SET_SETTINGS', null)
  },

  /**
   * Get stored ports or load and store
   *
   * @param commit
   * @param state
   * @returns {Promise<any>}
   */
  loadUpdates ({ commit, state }) {
    return new Promise(async (resolve, reject) => {
      if (state.settings == null) {
        const lastUpdateDate = getLastUpdateDate()

        const { updateDate, settings } = await getUpdatesSettings(lastUpdateDate)
        // Convert with moment to remove '+0000'
        const updateDateIso = moment(updateDate).utc(false).toISOString()

        putSettingsToStorage(settings)
        setLastUpdateDate(updateDateIso)

        const storedSettings = getStoredSettings()
        commit('SET_SETTINGS', storedSettings)
      }
      resolve(state.settings)
    })
  },
  setSetting ({ commit }, { name, value }) {
    commit('SET_SETTING', { name, value })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/settings.js